// @flow
import React from 'react';
import { MapPin } from '@finect/tabular-icons/mapPin';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { LocationFiltersBlock, FilterLocation, LocationOption } from './partials';

const capitalizeWord = (word: string) => `${word[0].toUpperCase()}${word.slice(1).toLowerCase()}`;

type Props = {
  staticContext?: Object,
  handleChange: Function,
  selectedLocation: number
};

type State = {
  locationFilters: Array<{ id: number, name: string }>,
  mainLocations: Array<{ id: number, name: string }>,
  restLocations: Array<{ id: number, name: string }>
};

export class LocationFilters extends React.Component<Props, State> {
  locationSelect: HTMLSelectElement | null;
  locationSelectMobile: HTMLSelectElement | null;

  state =
    typeof window === 'undefined'
      ? {
        locationFilters: (this.props.staticContext && this.props.staticContext.initialData.locationFilters.all) || [],
        mainLocations: (this.props.staticContext && this.props.staticContext.initialData.locationFilters.main) || [],
        restLocations: (this.props.staticContext && this.props.staticContext.initialData.locationFilters.rest) || []
      }
      : {
        locationFilters: (window.initialData && window.initialData.locationFilters.all) || [],
        mainLocations: (window.initialData && window.initialData.locationFilters.main) || [],
        restLocations: (window.initialData && window.initialData.locationFilters.rest) || []
      };

  componentDidMount() {
    if (!this.state.locationFilters.length) {
      LocationFilters.loadInitialData().then(
        locationFilters =>
          locationFilters &&
          this.setState({
            locationFilters: locationFilters.all,
            mainLocations: locationFilters.main,
            restLocations: locationFilters.rest
          })
      );
    }
  }

  handleChange = (event: SyntheticEvent<HTMLSelectElement>, id: number) => {
    // $FlowFixMe
    const selectedLocation = (event && Number(event.target.value)) || id || -1;
    let currentSelected = this.props.selectedLocation;

    if (id) {
      // $FlowFixMe
      this.locationSelect.value = '-1';
    } else {
      const exists = this.state.restLocations.find(location => location.id === selectedLocation);
      currentSelected = 0;
      // $FlowFixMe
      this.locationSelect.value = exists ? selectedLocation.toString() : '-1';
    }
    // $FlowFixMe
    this.locationSelectMobile.value = selectedLocation.toString();

    this.props.handleChange(currentSelected, selectedLocation);
  };

  static loadInitialData(cookie?: string) {
    return finectAPI({
      version: 'v3',
      path: 'advisers/locations',
      method: 'GET',
      credentials: cookie,
      onSuccess: (locationFilters: Array<Object>) => {
        const restLocations = [];
        const previewLocations = ['Madrid', 'Barcelona', 'Valencia', 'Murcia'];

        const cleanedLocations = locationFilters.map((location) => {
          const cleanedLocation = {
            id: location.id,
            name: capitalizeWord(location.name)
          };
          if (!previewLocations.includes(cleanedLocation.name)) {
            restLocations.push(cleanedLocation);
          }
          return cleanedLocation;
        });

        const mainLocations = previewLocations.map((name) => {
          const mainLocation = cleanedLocations.find(location => location.name === name);
          return mainLocation;
        });

        return {
          all: cleanedLocations,
          main: mainLocations,
          rest: restLocations
        };
      },
      onError: () => console.log('Request to advisers/locations failed!') // eslint-disable-line
    });
  }

  render() {
    const { locationFilters, mainLocations, restLocations } = this.state;
    const { selectedLocation } = this.props;
    const exists = restLocations.find(location => location.id === selectedLocation);

    return (
      <LocationFiltersBlock>
        <MapPin size="20" />
        <LocationOption id={-1} name="Todas" onClick={this.handleChange} selected={selectedLocation === -1} />
        {mainLocations
          .filter(location => typeof location === 'object')
          .map(location => (
            <LocationOption
              key={location.id}
              id={Number(location.id)}
              name={location.name}
              onClick={this.handleChange}
              selected={selectedLocation === location.id}
            />
          ))}
        <FilterLocation selected={exists}>
          <select ref={el => (this.locationSelect = el)} onChange={this.handleChange} defaultValue={selectedLocation}>
            <option value={-1} disabled>
              Otras localizaciones
            </option>
            {restLocations.map(location => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
        </FilterLocation>
        <FilterLocation mobile>
          <select
            ref={el => (this.locationSelectMobile = el)}
            onChange={this.handleChange}
            defaultValue={selectedLocation}
          >
            <option value={-1}>Cualquier localización</option>
            {locationFilters.length
              ? locationFilters.map(location => (
                <option key={location.id} value={location.id}>
                  {location.name}
                </option>
              ))
              : null}
          </select>
        </FilterLocation>
      </LocationFiltersBlock>
    );
  }
}
